// extracted by mini-css-extract-plugin
export default {"spinner_container":"Loader_spinner_container__KXLBK","spinner":"Loader_spinner__My9MQ","spinner-d3wgkg":"Loader_spinner-d3wgkg__b3L51"};